<template>
  <div>
    <a-modal :visible="previewImageVisible" :footer="null" @cancel="previewImageCancel">
      <img alt="example" style="width: 100%" :src="previewUrl" />
    </a-modal>
    <a-card :bordered="false" class="ant-card-0">
      <!-- 操作 -->
      <div class="table-operations-none">
        <table-setting
          :table-size.sync="tableSize"
          v-model="columns"
          :refresh-loading="loading"
          @refresh="getList" />
      </div>
      <!-- 增加修改 -->
      <create-form
        ref="createForm"
        @ok="getList"
      />
      <!-- 数据展示 -->
      <a-table
        :loading="loading"
        :size="tableSize"
        :showHeader=false
        rowKey="id"
        :columns="columns"
        :data-source="list"
        :pagination="false"
      >
        <span slot="createTime" slot-scope="text, record">
          {{ parseTime(record.createTime) }}
        </span>
        <template slot="icon" slot-scope="text, record">
          <div>
            <img v-if="record.icon" :src="record.icon" style="width:60px;height:60px;"
                 @click="handleRecordPreview(record.icon)" alt="none"/>
          </div>
        </template>
        <span slot="categoryLevel" slot-scope="text, record">
          <a-tag :color="record.categoryLevel === 1 ? 'blue' : 'green'">
            {{ record.categoryLevel === 1 ? $t('上门服务分类.一级分类') : $t('上门服务分类.二级分类') }}
          </a-tag>
        </span>
        <span slot="isHomeVisible" slot-scope="text, record">
          <custom-dict-tag :options="customDict.TFEnum" :value="record.isHomeVisible"/>
        </span>
        <span slot="operation" slot-scope="text, record">
          <a @click="$refs.createForm.handleUpdate(record)" v-hasPermi="['homeservice:category:edit']">
             <a-icon type="edit" />{{$t('通用.按钮.修改')}}
          </a>
          <a-divider type="vertical" v-hasPermi="['homeservice:category:remove']" />
          <a @click="handleDelete(record)" v-hasPermi="['homeservice:category:remove']">
            <a-icon type="delete" />{{$t('通用.按钮.删除')}}
          </a>
        </span>
      </a-table>
    </a-card>
  </div>
</template>

<script>
import { listCategory, delCategory } from '@/api/homeservice/category'
import CustomDictTag from "@/components/DictCustomTag";
import {mapGetters} from 'vuex'
import CreateForm from './modules/CreateForm'
import { tableMixin } from '@/store/table-mixin'
import bus from "@/utils/bus";

export default {
  name: 'HomeServiceCategorySubList',
  components: {
    CustomDictTag,
    CreateForm
  },
  props: {
    id: {
      type: [String, Number],
      required: true
    }
  },
  mixins: [tableMixin],
  data () {
    return {
      list: [],
      selectedRowKeys: [],
      selectedRows: [],
      //预览封面
      previewImageVisible: false,
      previewUrl: false,
      expandedKeys: [],
      // 高级搜索 展开/关闭
      advanced: false,
      // 非单个禁用
      single: true,
      // 非多个禁用
      multiple: true,
      ids: [],
      loading: false,
      total: 0,
      columns: [
        {
          title: this.$t('上门服务分类.分类名称'),
          ellipsis: true,
          width: '15%',
          dataIndex: 'categoryName',
          align: 'center'
        },
        {
          title: this.$t('上门服务分类.分类图标'),
          dataIndex: 'icon',
          scopedSlots: { customRender: 'icon' },
          align: 'center'
        },
        {
          title: this.$t('上门服务分类.分类级别'),
          dataIndex: 'categoryLevel',
          scopedSlots: { customRender: 'categoryLevel' },
          align: 'center'
        },
        {
          title: this.$t('上门服务分类.是否首页展示'),
          dataIndex: 'isHomeVisible',
          scopedSlots: { customRender: 'isHomeVisible' },
          align: 'center'
        },
        {
          title: this.$t('通用.文本.排序'),
          dataIndex: 'sort',
          align: 'center'
        },
        {
          title: this.$t('通用.文本.创建时间'),
          dataIndex: 'createTime',
          ellipsis: true,
          scopedSlots: { customRender: 'createTime' },
          align: 'center'
        },
        {
          title: this.$t('通用.文本.操作'),
          dataIndex: 'operation',
          width: '12%',
          scopedSlots: { customRender: 'operation' },
          align: 'center'
        }
      ]
    }
  },
  created () {
    this.getList()
    /**编辑页面接收到更新的数据 */
    bus.$on('updateCateChildrenList',()=>{
      this.getList()
    })
  },
  computed: {
    ...mapGetters(['customDict'])
  },
  watch: {
    id () {
      this.getList()
    }
  },
  methods: {
    /** 查询分类列表 */
    getList () {
      this.loading = true
      let query = {
        parentId: this.id,
        categoryLevel: 2
      }
      listCategory(query).then(response => {
        this.list = response.data
        this.loading = false
      })
    },
    previewImageCancel() {
      this.previewImageVisible = false;
    },
    handleRecordPreview(url) {
      this.previewUrl = url
      this.previewImageVisible = true
    },
    onSelectChange (selectedRowKeys, selectedRows) {
      this.selectedRowKeys = selectedRowKeys
      this.selectedRows = selectedRows
      this.ids = this.selectedRows.map(item => item.id)
      this.single = selectedRowKeys.length !== 1
      this.multiple = !selectedRowKeys.length
    },
    /** 删除按钮操作 */
    handleDelete (row) {
      var that = this
      const ids = row.id || this.ids
      if(row.id){
        this.ids = []
        this.ids.push(row.id)
      }
      this.$confirm({
        title: this.$t('通用.文本.确认删除所选中数据'),
        onOk () {
          let data = []
          that.ids.map(id => data.push({"id":id}))
          return delCategory(data)
            .then(() => {
              that.onSelectChange([], [])
              that.getList()
              that.$message.success(
                that.$t('通用.文本.删除成功'),
                3
              )
          })
        },
        onCancel () {
          //取消清空删除ids列表
          that.ids = []
        }
      })
    },
  }
}
</script>
<style>
.table-operations-none {
  display: none;
}
.ant-card-0>.ant-card-body {
  padding: 0px;
}

</style>
